"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientCommunicator = void 0;
const ClientCommunicatorUtils_1 = require("./ClientCommunicatorUtils");
class ClientCommunicator {
    constructor(allowedOrigins = [], source = 'client') {
        this._windowIsBlocked = false;
        this.cb = {};
        this.allowedOrigins = allowedOrigins;
        this.source = source;
    }
    get windowIsBlocked() {
        return this._windowIsBlocked;
    }
    set windowIsBlocked(value) {
        this._windowIsBlocked = value;
    }
    addAlmeMessageListener(callback) {
        const callbackId = ClientCommunicatorUtils_1.ClientCommunicatorUtils.uuidv4();
        const fn = (event) => {
            this.processIncoming(callback, event);
        };
        this.cb[callbackId] = fn;
        window.addEventListener('message', fn, false);
        return callbackId;
    }
    removeAlmeMessageListener(callbackId) {
        const fn = this.cb[callbackId];
        window.removeEventListener('message', fn, false);
        delete this.cb[callbackId];
    }
    processIncoming(callback, messageEvent) {
        if (this.windowIsBlocked) {
            return;
        }
        if (!this.validateOrigin(messageEvent)) {
            return;
        }
        // Message from client
        const data = this.validateSource(messageEvent);
        if (!data) {
            return;
        }
        // Assign ID to message
        data.message = Object.assign({}, data.message, {
            id: ClientCommunicatorUtils_1.ClientCommunicatorUtils.uuidv4(),
            createDateTime: (new Date()).getTime(),
            isProcessed: false,
        });
        const payload = {
            message: data.message,
        };
        if (typeof callback === 'function') {
            callback(payload);
        }
    }
    validateOrigin(messageEvent) {
        const messageOrigin = messageEvent.origin.toLowerCase();
        // Allow messages from main window (i.e. page including Alme scripts). 
        // Probably not a security concern - focus on 3rd-party scripts.
        if (messageOrigin === window.location.origin) {
            return true;
        }
        if (!this.allowedOrigins.length) {
            // Empty allowed origins accepts all.
            return true;
        }
        for (const origin of this.allowedOrigins) {
            const lcOrigin = origin.toLowerCase();
            // Exact match: www.domain.com
            if (messageOrigin === lcOrigin) {
                return true;
            }
            // *.domain.com -> sub1.domain.com, sub2.domain.com
            if (lcOrigin[0] === '*') {
                const suffix = lcOrigin.substring(1);
                // N.B. this works with very loose things like "*.com"
                if (suffix && messageOrigin.endsWith(suffix)) {
                    return true;
                }
            }
        }
        return false;
    }
    validateSource(messageEvent) {
        if (!messageEvent.data) {
            return null;
        }
        let data;
        try {
            if (typeof messageEvent.data === 'object' &&
                messageEvent.data.message &&
                messageEvent.data.message.source) {
                data = messageEvent.data;
            }
            else if (typeof messageEvent.data === 'string') {
                data = JSON.parse(messageEvent.data);
            }
            else {
                return null;
            }
        }
        catch (e) {
            //This JSON string is likely coming from XDomain which it contains [object, object] which parse will throw exception for
            return null;
        }
        if (!data || !data.message || !data.message.source || typeof data.message.source !== 'string') {
            return null;
        }
        return this.source.toLowerCase() === data.message.source.toLowerCase() ? data : null;
    }
}
exports.ClientCommunicator = ClientCommunicator;
//# sourceMappingURL=ClientCommunicator.js.map